// Formatadores compartilhados pelas abas de tabela do Leilão CLT
// (Progresso leilão / Histórico leilão).

export const formatDateTime = (raw?: string | null): string => {
  if (!raw) return "-";
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDate = (raw?: string | null): string => {
  if (!raw) return "-";
  // Data pura yyyy-MM-dd (ex.: dataNascimento) é formatada sem passar por
  // `new Date`, que interpretaria como UTC e poderia exibir o dia anterior
  // em fusos negativos (BRT). Outros formatos caem no parse padrão.
  const isoDate = /^(\d{4})-(\d{2})-(\d{2})/.exec(raw);
  if (isoDate) {
    const [, year, month, day] = isoDate;
    return `${day}/${month}/${year}`;
  }
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const formatRate = (rate?: number | null): string => {
  if (rate == null) return "-";
  return `${rate.toFixed(2)}%`;
};

export const toTitleCase = (name?: string | null): string => {
  if (!name) return "-";
  return name
    .toLocaleLowerCase("pt-BR")
    .replace(/\p{L}+/gu, (word) => word.charAt(0).toLocaleUpperCase("pt-BR") + word.slice(1));
};
